<kendo-button kendoButton themeColor="primary" [disabled]="isLoading"  (click)="eksportuoti()">
  {{ 'button.eksportuoti' | translate }}
</kendo-button>
